import registerInfo from "@src/global/registerInfo"
import sessionStorageService from "@src/utils/sessionStorage"
import storageKeys from "@src/config/storageKeys"
// import LoginService from "@src/system/login/index"
import XmApis from "@src/request/xm/apis"

export default class AppService {
  constructor() {}

  /**
   * @description 应用注册
   * @author liupl
   * @date 2021-07-20
   * @param {object} params
   * @param {string!} params.env
   * @param {string!} params.appName
   * @return {boolean}
   * @memberof AppService
   */
  register({ env, appName }) {
    registerInfo.env = env
    registerInfo.appName = appName
    this.env = env
    this.appName = appName
    return true
  }

  getAppInfo() {
    // const appName = this.appName
    let appBaseInfo = sessionStorageService.getItem(storageKeys.VOCUST_APP_BASE_ID.key)
    // if (!appBaseInfo || appBaseInfo.appName !== appName || !appBaseInfo.ssoToken) {
    //   const loginService = new LoginService()
    //   appBaseInfo = await loginService.login()
    // }
    return appBaseInfo
  }

  async getMenus() {
    const xmApis = new XmApis(registerInfo)
    const menus = await xmApis.getMenus()
    console.log(menus)
    return []
  }
}
